import { baseApi } from 'api/base';
import { SupervisedObjectWrapper } from 'types/types';
import { InitInfo, PatentHolder } from './types';

const get = async () => {
  const res = await baseApi.get('/user/principal');
  if (!res.data) {
    return null;
  }
  return res.data;
};

const getInitInfo = async (): Promise<InitInfo> => {
  const res = await baseApi.get('/init-info');
  return res.data;
};

const clarification = async (data: PatentHolder & SupervisedObjectWrapper) => {
  await baseApi.post('/user/clarification', data);
};

export const userDataApi = {
  get,
  clarification,
  getInitInfo,
};
